module.exports = __webpack_public_path__ + "static/img/njs.1e85b235.png";